import { StormDoorColor } from './storm-door-color';

export interface IProductTexture {
    id: string;
    name: string;
    swatchUrl: string;
    productImageUrls: string[];
    colorFamily: StormDoorColor;
}


export class ProductTexture implements IProductTexture {
    public id: string = '';
    public name: string = '';
    public swatchUrl: string = '';
    public productImageUrls: string[] = [];
    public colorFamily: StormDoorColor = StormDoorColor.Indeterminate;
}


